import React, { useEffect, useState } from 'react'

import LoadingState from 'Pods/ThreeDStudio/Shared/LoadingState/LoadingState'

let ImageGalleryPanel = null
let imageGalleryImportPromise = null

export const importImageGalleryPanel = () => {
  if (!imageGalleryImportPromise) {
    imageGalleryImportPromise = import(
      /* webpackChunkName: "image-gallery-panel" */
      'Pods/LazyLoaded/ImageGalleryPanel/ImageGalleryPanel'
    ).then((mod) => { ImageGalleryPanel = mod.default })
  }
  return imageGalleryImportPromise
}

function LazyImageGalleryPanel() {
  const [isLoaded, setIsLoaded] = useState(() => !!ImageGalleryPanel)

  useEffect(() => {
    if (!ImageGalleryPanel) {
      importImageGalleryPanel().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !ImageGalleryPanel) return <LoadingState />
  return <ImageGalleryPanel />
}

export default LazyImageGalleryPanel
